/**
 * HTTP client for WFS / WMS calls made by WFSCrudService.
 *
 * Wraps the three flavours of request:
 *   - postXml          → WFS GetFeature with an XML body
 *   - postTransactionXml → WFS-T Transaction with an XML body
 *   - getFeatureInfo   → WMS GetFeatureInfo
 *
 * Returns raw `response.data` to the caller so response-shape parsing
 * (GeoJSON → EsriJson, numberOfFeatures regex, ExceptionReport detection)
 * stays in WFSCrudService where it belongs.
 *
 * Errors propagate; logging in the client stays at console.error for
 * parity with the other clients.
 */
import axios from 'axios'

export const wfsClient = {
  async postXml<T = unknown>(namespacedUrl: string, xml: string): Promise<T> {
    try {
      const r = await axios.post<T>(`${namespacedUrl}/wfs`, xml, {
        headers: {'Content-Type': 'text/plain;charset=UTF-8'}
      })
      return r.data
    } catch (e) {
      console.error('wfsClient.postXml failed', e)
      throw e
    }
  },

  async postTransactionXml<T = unknown>(layerBaseUrl: string, xml: string): Promise<T> {
    try {
      const r = await axios.post<T>(`${layerBaseUrl}/wfs`, xml, {
        headers: {'Content-Type': 'text/xml'}
      })
      return r.data
    } catch (e) {
      console.error('wfsClient.postTransactionXml failed', e)
      throw e
    }
  },

  async getFeatureInfo<T = unknown>(namespacedUrl: string, queryString: string): Promise<T> {
    try {
      const r = await axios.get<T>(`${namespacedUrl}/wms?${queryString}`)
      return r.data
    } catch (e) {
      console.error('wfsClient.getFeatureInfo failed', e)
      throw e
    }
  }
}
